import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Divider,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";

export default function ViewSupportMessage({ open, onClose, data }) {
  if (!data) return null;

  const { name, email, subject, message, adminReplies = [], createdAt } = data;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pr: 5 }}>
        Support Message
        <IconButton
          aria-label="Close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {/* User Information */}
        <Box mb={2}>
          <Typography variant="body1" gutterBottom><strong>Name:</strong> {name}</Typography>
          <Typography variant="body1" gutterBottom><strong>Email:</strong> {email}</Typography>
          <Typography variant="body1"><strong>Subject:</strong> {subject}</Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Conversation Thread */}
        <Box
          display="flex"
          flexDirection="column-reverse"
          gap={2}
          maxHeight={400}
          overflow="auto"
          px={1}
        >
          {/* Admin Replies */}
          {adminReplies.slice().reverse().map((reply, index) => (
            <Box
              key={index}
              alignSelf="flex-end"
              bgcolor="primary.light"
              color="primary.contrastText"
              maxWidth="75%"
              px={2}
              py={1.5}
              borderRadius={2}
              boxShadow={1}
            >
              <Typography variant="body2">{reply.replyMessage}</Typography>
              <Typography variant="caption" color="text.secondary">
                {dayjs(reply.repliedAt).format("MMM D, YYYY h:mm A")}
              </Typography>
            </Box>
          ))}

          {/* User Message */}
          <Box
            alignSelf="flex-start"
            bgcolor=""
            maxWidth="75%"
            px={2}
            py={1.5}
            borderRadius={2}
            boxShadow={1}
          >
            <Typography variant="body2">{message}</Typography>
            <Typography variant="caption" color="text.secondary">
              {dayjs(createdAt).format("MMM D, YYYY h:mm A")}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
